import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ScratchpadHistoryCompare,
  ScratchpadHistoryCompareProps,
} from './scratchpad-history-compare';

export interface ScratchpadHistoryCompareModalProps
  extends ScratchpadHistoryCompareProps {
  dismiss?: () => void;
}

const ScratchpadHistoryCompareModal = (
  props: ScratchpadHistoryCompareModalProps
): ReactElement => {
  const { dismiss, scratchpadId, selectedHistoryItemId, nextHistoryItemId } =
    props;
  const { i18n } = useTranslation();

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={dismiss}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>
            {i18n.t('common:scratchpad_version_compare_page_title')}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <ScratchpadHistoryCompare
          scratchpadId={scratchpadId}
          selectedHistoryItemId={selectedHistoryItemId}
          nextHistoryItemId={nextHistoryItemId}
        />
      </IonContent>
    </>
  );
};

export { ScratchpadHistoryCompareModal };
